import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import HaltIcon from "../icons/HaltIcon";
import HaltOrderForm from "../forms/HaltOrderForm";
import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { changeCommandStatus } from "../../mutations/command.mutations";

type HaltOrderModalProps = {
	orderId: number;
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function HaltOrderModal({
	orderId,
	isOpen,
	onOpen: _,
	onClose,
}: HaltOrderModalProps) {
	const { mutate: mutateCommandStatus } = useMutation(changeCommandStatus);
	const queryClient = useQueryClient();
	const handleSubmit = useCallback(
		(data: { reason: string; explanation: string; status: string }) => {
			mutateCommandStatus(
				{
					id: orderId,
					status: data.status,
					reason: data.reason,
					explanation: data.explanation,
				},
				{
					onSettled: async () => {
						await queryClient.invalidateQueries();
						onClose();
					},
				},
			);
		},
		[orderId, mutateCommandStatus, onClose],
	);
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<HaltIcon w="24px" h="24px" color="brand.700"></HaltIcon>
						</Flex>
						<Box lineHeight="48px">Mettre en pause la commande</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<HaltOrderForm
						id={orderId}
						onClose={onClose}
						onSubmit={handleSubmit}
					></HaltOrderForm>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default HaltOrderModal;
